module.exports = __webpack_public_path__ + "img/qilin-f-stage7-hungry.b5c72e8f.png";